/**
 * Route path segments on which the "Ask Opal" overlay button and chat panel are available.
 * Used by both the global header (to render the button) and the overlay (to stay open).
 */
export const OVERLAY_PAGE_SEGMENTS = [
  'instructions',
  'skills',
  'agents',
  'tools',
  'context',
  'vaus',
];
